import type { ColumnsBlockModel } from '@blocksuite/affine-model';
import { BlockComponent } from '@blocksuite/std';
import { html } from 'lit';

import { columnsContainerStyles, columnsHostStyles } from './styles.js';

export class ColumnsBlockComponent extends BlockComponent<ColumnsBlockModel> {
  override connectedCallback() {
    super.connectedCallback();
    // Shadowless elements get no `:host`, so the host rule is a class.
    this.classList.add(columnsHostStyles);
  }

  override renderBlock() {
    return html`
      <div class="affine-columns-container ${columnsContainerStyles}">
        ${this.renderChildren(this.model)}
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'affine-columns': ColumnsBlockComponent;
  }
}
